import React from "react";

import styled from "@emotion/styled";

import LinkComponent from "../../../../../shared/LinkComponent";
import CartPriceBreakdown from "../../../ShoppingCart/CartPriceBreakdown";
import CartProductItem from "../../../ShoppingCart/CartProductItem";
import {
    iShopwareCartDelivery,
    iShopwareCartLineItem,
    iShopwareCartPrice,
} from "../../../ShoppingCart/store";
import { InlineFlex, SubTitle } from "../index";

const CartLink = styled(LinkComponent)`
    text-decoration: underline;
`;

const CartContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 2em;
`;

interface iCartSummaryProps {
    cartItems: iShopwareCartLineItem[];
    cartPrice: iShopwareCartPrice;
    cartDelivery: iShopwareCartDelivery;
}

const CartSummary = ({
    cartItems,
    cartPrice,
    cartDelivery,
}: iCartSummaryProps) => {
    return (
        <CartContainer>
            <InlineFlex>
                <SubTitle>Warenkorb</SubTitle>
                <CartLink
                    color="darkGrey"
                    fontSize="0.75rem"
                    link={{
                        text: "Ändern",
                        href: "/shop/warenkorb",
                    }}
                />
            </InlineFlex>

            {cartItems.map((product) => (
                <CartProductItem
                    key={product.id}
                    cartProduct={product}
                    readonly
                />
            ))}
            <hr />
            <CartPriceBreakdown
                price={cartPrice}
                delivery={cartDelivery}
                headline=""
            />
        </CartContainer>
    );
};

export default CartSummary;
